@if (!readOnly()) {
  <div class="rounded border border-(--pg-border-strong) bg-(--pg-surface-soft) p-3">
    <h3 class="mb-1 text-sm font-medium text-(--pg-text)">{{ title() }}</h3>
    @if (description()) {
      <p class="mb-2 text-sm text-(--pg-text-muted)">{{ description() }}</p>
    }
    <div class="flex flex-wrap items-center gap-3">
      <button mat-stroked-button type="button" (click)="sendCode()" [disabled]="!canSend() || busy() || resendIn() > 0">
        <mat-icon>sms</mat-icon>
        {{ sentTo() ? 'Send a new code' : sendLabel() }}
      </button>
      @if (busy()) {
        <mat-spinner diameter="20" />
      }
      @if (resendIn() > 0) {
        <span class="text-sm text-(--pg-text-muted)">Another code can be sent in {{ resendIn() }} seconds.</span>
      }
    </div>
    @if (info(); as text) {
      <p class="mt-2 text-sm text-(--pg-text)" role="status">{{ text }}</p>
    }
    @if (sentTo()) {
      <div class="mt-3 flex flex-wrap items-start gap-3">
        <mat-form-field appearance="outline" class="w-full sm:w-64">
          <mat-label>Code the member reads out</mat-label>
          <input matInput inputmode="numeric" maxlength="10" autocomplete="one-time-code" [value]="code()" (input)="codeTyped($event)" />
        </mat-form-field>
        <button mat-flat-button type="button" class="sm:mt-2" (click)="verifyCode()" [disabled]="!canVerify()">Verify the code</button>
      </div>
    }
  </div>
}
